import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { AuthService } from '@app-services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
	get as _get
} from 'lodash';
import { NbDialogService, NbGlobalPhysicalPosition, NbGlobalPosition, NbToastrService } from '@nebular/theme';
import { Store, select } from '@ngrx/store';
import { NbComponentStatus } from '@nebular/theme';
import { TranslationService } from "@app-services/translation.service";
@Component({
	selector: 'ngx-verifycode',
	templateUrl: './verifycode.component.html',
	styleUrls: ['./verifycode.component.scss']
})
export class VerifycodeComponent implements OnInit {
	form: UntypedFormGroup;
	newform: UntypedFormGroup;
	loading = false;
	email;
	errorMessage: string = '';
	codecontainer = false;
	passwordcontainer = false;
	private _duration = 2000;
	private _position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
	private _preventDuplicates = false;
	private _viewInited: boolean = false;
	private _unsubscribeAll: Subject<any>;

	constructor(
		private _router: Router,
		private _formBuilder: UntypedFormBuilder,
		private auth: AuthService,
		private _toastrService: NbToastrService,
		private route: ActivatedRoute,
		private _translationService: TranslationService,

	) {
		this._unsubscribeAll = new Subject();


	}

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			if (params['email']) {
				this.email = params['email']
			}
		});
		this.codecontainer = true
		this.form = this._formBuilder.group({
			code: ['', [Validators.required]],


		});
		this.newform = this._formBuilder.group({

			password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(255)]],


		});
	}
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
	onVerify() {
		if (this.form.invalid)
			return;
		this.errorMessage = null;

		this.auth.verifycode(this.email, this.form.value.code).pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
			if (res.success == false) {
				this.showToast('danger', this._translationService.translate('Common.Failed'), this._translationService.translate(`Common.${res.message}`));
			} else {
				this.showToast('success', this._translationService.translate('Common.Success'), this._translationService.translate(`Common.${res.message}`));
				this.codecontainer = false
				this.passwordcontainer = true
			}
		}, (err) => {

		});
	}

	private showToast(type: NbComponentStatus, title: string, body: string) {
		const config = {
			status: type,
			destroyByClick: true,
			duration: this._duration,
			hasIcon: true,
			position: this._position,
			preventDuplicates: this._preventDuplicates,
		};
		const titleContent = title ? `. ${title}` : '';

		this._toastrService.show(
			body,
			`${titleContent}`,
			config);
	}
	onresetpassword() {
		this.auth.resetpassword(this.email, this.form.value.code, this.newform.value.password).pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
			if (res.success == false) {
				this.showToast('danger', this._translationService.translate('Common.Failed'), this._translationService.translate(`Common.${res.message}`));
			} else {
				this.showToast('success', this._translationService.translate('Common.Success'), this._translationService.translate(`Common.${res.message}`));
				this._router.navigate(['/login'])
			}
		}, (err) => {

		});
	}
}
